import { TwoFactorAuthTypesApiPaths, TwoFactorAuthTypesComponents } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

const client = new RestClient(TwoFactorAuthTypesApiPaths.PostApiAuth2faDisable, {}, resolveDomain(), { mode: 'cors', referrerPolicy: 'no-referrer' })

export const disable2FaAuthHandler = async (data: TwoFactorAuthTypesComponents['schemas']['2FaDisableInput']) => {
  await client.post<TwoFactorAuthTypesComponents['schemas']['2FaDisableInput'], Response>('', data, {
    'Content-Type': 'application/json',
  })
}
